import React from 'react';
import { Dropdown } from 'antd';
import { Link } from 'react-router-dom';

import { useTopNavAuthService } from '../menuService';
import { DownOutlined } from '@/icons';
import { isDefaultCon, showAtDev } from '@/env';
import MenuOverlay from './MenuOverlay';
import AppModuleMenu from './AppModuleMenu';
import DocsLink from '../DocsLink';

import styles from './FlowHeaderMenu.module.less';

function FlowHeaderMenu() {
    const { customerEntry, conversationEntry, adminEntry, shareEntry } = useTopNavAuthService();

    return (
        <div className={styles.container}>
            <ul className={styles.menu}>
                <AppModuleMenu />

                {conversationEntry && (
                    <li>
                        {isDefaultCon() ? (
                            <Dropdown
                                overlay={<MenuOverlay menuKey="converstaionMenu" />}
                                placement="bottomCenter"
                            >
                                <button>
                                    会话管理
                                    <DownOutlined style={{ marginLeft: 10 }} />
                                </button>
                            </Dropdown>
                        ) : (
                            <Link to="/conversation">会话管理</Link>
                        )}
                    </li>
                )}

                {customerEntry && (
                    <li>
                        <Dropdown
                            overlay={<MenuOverlay menuKey="customerMenu" />}
                            placement="bottomCenter"
                        >
                            <Link to="/customer/statistic">
                                客户管理 <DownOutlined style={{ marginLeft: 10 }} />
                            </Link>
                        </Dropdown>
                    </li>
                )}

                {adminEntry && (
                    <li>
                        <Dropdown
                            overlay={<MenuOverlay menuKey="adminMenu" />}
                            placement="bottomCenter"
                        >
                            <Link to="/admin/departs">
                                系统管理 <DownOutlined style={{ marginLeft: 10 }} />
                            </Link>
                        </Dropdown>
                    </li>
                )}
                {shareEntry && (
                    <li>
                        <Dropdown
                            overlay={<MenuOverlay menuKey="wechatMenu" />}
                            placement="bottomCenter"
                        >
                            <Link to="/wechat/fileManagement">
                                艾智享 <DownOutlined style={{ marginLeft: 10 }} />
                            </Link>
                        </Dropdown>
                    </li>
                )}


                {/* {showAtDev && (
                    <li>
                        <Link to="/dev/icons">Icons</Link>
                    </li>
                )} */}
            </ul>
        </div>
    );
}

export default FlowHeaderMenu;
